import { Icon } from 'react-native-elements/dist/icons/Icon';
import { LinearGradient } from 'expo-linear-gradient';
import PropTypes from 'prop-types';
import React from 'react';
import { Text } from 'react-native-elements';
import { View, TouchableOpacity } from 'react-native';
import { isWeb } from '../../utils/platform.utils';
import theme from '../theme';

export const VerifyAccount = ({ product, selected, onSelect }) => {
    return (
        <TouchableOpacity
            onPress={() => onSelect(product.id)}
            activeOpacity={0.5}
            style={!isWeb() ? { ...theme.shadows.lightBlue } : null}
        >
            <LinearGradient
                {...theme.gradients.lightBlue}
                style={{
                    justifyContent: 'center',
                    borderWidth: 2,
                    boxShadow: selected
                        ? '0px 6px 6px -3px rgba(0, 0, 0, 0.2), 0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 4px 18px 3px rgba(0, 0, 0, 0.12)'
                        : null,
                    borderColor: selected
                        ? theme.colors.phthaloBlue
                        : 'rgba(0,0,0,0.2)',
                    backgroundColor: '#FFFFFF',
                    marginBottom: 25,
                    borderRadius: 10,
                    padding: 16,
                }}
            >
                <View
                    style={{
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    <Text
                        style={{
                            fontSize: 17,
                            flex: 1,
                            fontFamily: 'DMSans_700Bold',
                        }}
                    >
                        {product.name}
                    </Text>
                    {selected && (
                        <Icon
                            name="checkmark-circle"
                            type="ionicon"
                            size={22}
                            color={theme.colors.phthaloBlue}
                        />
                    )}
                </View>
            </LinearGradient>
        </TouchableOpacity>
    );
};

VerifyAccount.propTypes = {
    product: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
    }),
    selected: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
};
